import React from "react";
import { useState } from "react";
import '../../styles/QueryStyles/QueryForm.css';

const QueryForm = () => {

    const WHATSAPP_NUMBER = "27645406751"; // your number, no + or spaces

    const [form, setForm] = useState({
        fullName: "",
        phoneNum: "",
        email: "",
        subject: "General Question",
        message: "",
    });

    const [showPreview, setShowPreview] = useState(false);

    // Update form state on every input change
    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
        setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    // Build the WhatsApp message
    const buildMessage = () => {
        return (
        `Hello Kole Medical! \n\n` +
        `*Name:* ${form.fullName}\n` +
        `*Phone:* ${form.phoneNum || "Not provided"}\n` +
        `*Email:* ${form.email}\n` +
        `*Subject:* ${form.subject}\n\n` +
        `*Message:*\n${form.message}`
        );
    };

    // Validate required fields before showing preview
    const handleSubmitClick = () => {
        if (!form.fullName || !form.email || !form.message) {
        alert("Please fill in all required fields.");
        return;
        }
        setShowPreview(true); // show preview modal first
    };

    // User confirms — open WhatsApp
    const handleConfirm = () => {
        const encoded = encodeURIComponent(buildMessage());
        const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encoded}`;
        window.open(url, "_blank");
        setShowPreview(false);
    };

    return(
        <section className="queryFormContainer">
            <form action="">
                 <div className="top-content">
                    <div className="left-content">

                        <div className="form-group">
                            <label htmlFor="fullName">Full Name</label>
                            <input
                                type="text"
                                name="fullName"
                                id="fullName"
                                value={form.fullName}
                                onChange={handleChange}
                                required
                                />
                        </div>

                        <div className="form-group">
                            <label htmlFor="phoneNum">Phone Number</label>
                            <input
                                type="tel"
                                name="phoneNum"
                                id="phoneNum"
                                value={form.phoneNum}
                                onChange={handleChange}
                                />
                        </div>

                        <div className="form-group">
                            <label htmlFor="email">Email Address</label>
                             <input
                                type="email"
                                name="email"
                                id="email"
                                value={form.email}
                                onChange={handleChange}
                                required
                                />
                            </div>

                        <div className="form-dropdown">
                            <label htmlFor="subject">Subject</label>
                            <select name="subject" id="subject" value={form.subject} onChange={handleChange}>
                                <option value="General Question">General Question</option>
                                <option value="Licensing Help">Licensing Help</option>
                                <option value="Pricing / Quote">Pricing / Quote</option>
                                <option value="Webinars & Workshops">Webinars &amp; Workshops</option>
                            </select>
                        </div>
                    </div>
                    <hr />
                    <div className="right-content">
                        <div className="form-group">
                            <label htmlFor="message">Message</label>
                            <textarea
                                name="message"
                                id="message"
                                value={form.message}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                 </div>
                <div className="bottom-content">
                    <div className="submitSection">
                        {/* Clicking this shows the preview — does NOT submit the form */}
                        <button type="button" onClick={handleSubmitClick}>
                        Send Query
                        </button>
                        <p>Your query is sent to us on WhatsApp. We will reply there, or by email or phone.</p>
                    </div>
                </div>
            </form>

                  {/* ── PREVIEW MODAL ── */}
                {showPreview && (
                    <div className="preview-overlay">
                    <div className="preview-modal">

                        <div className="preview-header">
                        <span className="preview-icon">💬</span>
                        <h3>Preview Your Message</h3>
                        <p>This is what will be sent to our WhatsApp</p>
                        </div>

                        <div className="preview-body">
                        <pre>{buildMessage()}</pre>
                        </div>

                        <div className="preview-actions">
                        {/* Go back and edit */}
                        <button
                            className="btn-edit"
                            onClick={() => setShowPreview(false)}
                        >
                            ← Edit
                        </button>

                        {/* Confirm and open WhatsApp */}
                        <button
                            className="btn-confirm"
                            onClick={handleConfirm}
                        >
                            ✓ Send on WhatsApp
                        </button>
                        </div>

                    </div>
                    </div>
                )}
        </section>
    );
};

export default QueryForm;